import type { PsfPromoteOrSharePageData, PsfShareFirstSocialStarterExperiment } from '../types';

/** Combo's static control fallback: `fallback: true` keeps exposure tracking from firing for it. */
export const PSF_SHARE_FIRST_SOCIAL_STARTER_COMBO_FALLBACK: PsfShareFirstSocialStarterExperiment = {
	type: 'growthbook',
	experimentName: '',
	variation: 'control',
	variantKey: '',
	featureKey: '',
	config: false,
	treated: false,
	fallback: true,
	fallbackReason: 'not-enrolled',
};

type SocialStarterControlExperiments = Pick<
	PsfPromoteOrSharePageData,
	| 'whatsappHeadlineExperiment'
	| 'advocateEntryPointExperiment'
	| 'promoteShareOnComboExperiment'
	| 'psfComboCopyExperiment'
	| 'psfPromoteOrShareFacebookPostSheetExperiment'
>;

/**
 * Static control values for every combo experiment the Social Starter route's query never resolves.
 * `fallback: true` / `treated: false` (and `config.enabled: false` where present) keep exposure tracking
 * and treat-on-action hooks inert for all of them.
 */
export const SOCIAL_STARTER_CONTROL_EXPERIMENTS: SocialStarterControlExperiments = {
	whatsappHeadlineExperiment: {
		variation: 'control',
		name: '',
		variants: {},
	},
	advocateEntryPointExperiment: {
		variation: 'control',
		name: '',
	},
	promoteShareOnComboExperiment: {
		variation: 'control',
	},
	psfComboCopyExperiment: {
		type: 'experiment-service',
		experimentName: '',
		variation: 'control',
		config: { copy: undefined },
		treated: false,
		fallback: true,
		fallbackReason: 'not-enrolled',
	},
	psfPromoteOrShareFacebookPostSheetExperiment: {
		type: 'experiment-service',
		experimentName: '',
		variation: 'control',
		config: { enabled: false },
		treated: false,
		fallback: true,
		fallbackReason: 'not-enrolled',
	},
};
